<template>

    <div id="app" class="d-flex flex-column">
        <div class="page-content">
            <Header v-if="$router.history.current.path !== '/login'"></Header>
            <div class="page-content mb-3">
                <router-view/>

            </div>
        </div>
        <Footer v-if="$router.history.current.path !== '/login'" class="sticky-footer"></Footer>
    </div>

</template>

<script>
  import Vue from 'vue'
  import Header from './components/Header'
  import Footer from './components/Footer'

  export default {
    name: 'App',

    components: {
      Header,
      Footer
    },

    data () {
      return {}
    },
      mounted() {
        console.log("router: ", this.$router.history.current.path)
      }
  }
</script>





// WEBPACK FOOTER //
// src/App.vue